<mc-file-watcher (changed)="update(sanitize($event))" [autostart]="true"></mc-file-watcher>

<mc-drivers-list [drivers]="drivers"></mc-drivers-list>
